import { render, staticRenderFns } from "./b2bRegister.vue?vue&type=template&id=43a3e611&"
import script from "./b2bRegister.vue?vue&type=script&lang=js&"
export * from "./b2bRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports